
const digest = 'a97f78dec2d8bebee9caecf65fc2ca3317835a05654ac7518817ad0d00b64396';
const classes = {"inline":"_inline_154zd_1","addressSection":"_addressSection_154zd_10","addressWrapper":"_addressWrapper_154zd_14"};
const css = `._inline_154zd_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._inline_154zd_1 > div {
  flex: 1;
}

._addressSection_154zd_10 {
  margin-bottom: 16px;
}

._addressWrapper_154zd_14 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  